window.addEventListener('DOMContentLoaded', (event) => {
    const articles = document.querySelectorAll('.featured-posts-row article')
    let timeoutHandler
    articles.forEach(article => article.addEventListener('mouseenter', e => {
        clearTimeout(timeoutHandler)

        e.target.style.height = e.target.clientHeight + 'px'
        e.target.classList.add('hover')
    }))
  articles.forEach(article => article.addEventListener('mouseleave', e => {
        e.target.classList.remove('hover')
        timeoutHandler = setTimeout(() => {
            e.target.style.removeProperty('height')
        }, 500)
    }))

});



